import { Injectable } from "@angular/core";
import { Jurisdiction } from "@obg/core.config";
import { head, map as lodashMap, unescape } from "lodash-es";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";

import { CommonContentClient } from "../content/common-content.client";

import { HOME_CONTENT_WIDGET_DOCUMENT_NAME } from "./home-content-widget.const";
import { HomeContentWidget, HomeContentWidgetResponseItem } from "./home-content-widget.model";

@Injectable({
	providedIn: "root",
})
export class HomeContentWidgetService {
	constructor(private service: CommonContentClient) {}

	get(searchParams?: {
		isLoggedIn: boolean;
		jurisdiction: Jurisdiction | undefined;
	}): Observable<HomeContentWidget[]> {
		return this.service
			.getCommonContent(HOME_CONTENT_WIDGET_DOCUMENT_NAME, searchParams)
			.pipe(map((result) => lodashMap(result, (item) => this.processHomeContentWidget(item))));
	}

	private processHomeContentWidget(rawItem: HomeContentWidgetResponseItem): HomeContentWidget {
		const content = rawItem.content;
		return {
			key: rawItem.documentKey,
			image: head(content.image),
			title: unescape(head(content.title)),
			ctaUrl: head(content.ctaUrl),
			ctaLabel: head(content.ctaLabel),
			description: unescape(head(content.description)),
		};
	}
}
